var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Appendix',{attrs:{"title":"Phụ lục phần mềm","fields":_vm.fieldsTable,"actions":_vm.actions,"excepts":_vm.excepts,"only":_vm.only,"items":_vm.items,"contract":_vm.contract},scopedSlots:_vm._u([{key:"row-details",fn:function(item){return [_vm._t("row-details",null,null,item)]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }